import {
    getNameOrId,
    ProductNames,
    ProductType,
} from '@/libs/product'
import { createGeneralProductInformationValidation } from '../general-product-information/general-product-information-validator'

const hasSection = (settings, section) => (
    Array.isArray(settings && settings.sections) && settings.sections.includes(section)
)

const createGeneralProductInformationV2Validation = (context = {}, settings = {}) => {
    if (context.mode === 'bulk') {
        const selection = context.bulkReplyCandidates || {}
        const selectedRequestIds = Array.isArray(selection.selectedRequestIds)
            ? selection.selectedRequestIds
            : []

        return createGeneralProductInformationValidation(
            selection.loaded === true && selectedRequestIds.length > 0,
        )
    }

    const product = context.product || (context.request && context.request.product) || {}
    const request = context.request || {}
    const suppliers = Array.isArray(product.suppliers) ? product.suppliers : []
    const productName = getNameOrId(product.names || [], ProductNames.OUR_PRODUCT_NAME) || ''
    const supplierName = getNameOrId(product.names || [], ProductNames.SUPPLIERS_PRODUCT_NAME) || ''
    let isValid = productName.trim().length > 0

    if (hasSection(settings, 'purchase-source')) {
        isValid = isValid && product.type !== ProductType.UNDEFINED

        if (product.type === ProductType.PURCHASED_UNDEFINED_SUPPLIER) {
            isValid = isValid && request.isComplexProduct !== null
        } else if (product.type === ProductType.PURCHASED) {
            isValid = isValid && suppliers.length > 0
                && supplierName.trim().length > 0
                && request.isComplexProduct !== null
        } else if (product.type === ProductType.OWN) {
            isValid = isValid && request.isComplexProduct !== null
        }
    }

    if (hasSection(settings, 'material-mixture-categories')) {
        isValid = isValid && (
            (product.materialCategoryIds || []).length > 0
            || (product.mixtureCategoryIds || []).length > 0
        )
    }

    return createGeneralProductInformationValidation(isValid)
}

export { createGeneralProductInformationV2Validation }
export default createGeneralProductInformationV2Validation
